import { Injectable } from "@angular/core";
import { MessageModalComponent } from "@app/shared/components/message-modal/message-modal.component";
import { FeedbackType } from "@app/shared/models/feedbackType";
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";

@Injectable({
  providedIn: "root",
})
export class FeedbackService {
  constructor(private modalService: NgbModal, private config: NgbModalConfig) {
    this.config.centered = true;
  }

  openModal(type: FeedbackType, title: string, message: string) {
    const modalRef = this.modalService.open(MessageModalComponent, {
      windowClass: "myCustomModalClass",
    });
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;

    return modalRef;
  }
}
